export default __webpack_public_path__ + "static/media/2002-IMcover.4e918419.jpg";